<div id="quickActions">
  <ul>
    <li *ngIf="display.size !== 'xsmall'">
      <button (click)="validate()" [disabled]="!canValidate" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_check"></span>
        <span *ngIf="!isConference" class="quickActionLabel">{{ 'agent:contact.actions.validate_transfer' | translate }}</span>
        <span *ngIf="isConference" class="quickActionLabel">{{ 'agent:contact.actions.validate_conference' | translate }}</span>
      </button>
    </li>
    <li *ngIf="display.size !== 'xsmall'">
      <button (click)="cancel()" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_annuler"></span>
        <span *ngIf="!isConference" class="quickActionLabel">{{ 'agent:contact.actions.cancel_transfer' | translate }}</span>
        <span *ngIf="isConference" class="quickActionLabel">{{ 'agent:contact.actions.cancel_conference' | translate }}</span>
      </button>
    </li>
    <li *ngIf="display.size === 'xsmall'">
      <button class="quickActionIcon" (click)="toggleMoreMenu = !toggleMoreMenu" [attr.aria-expanded]="toggleMoreMenu">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_menu_bullets"></span>
        <span class="quickActionLabel">{{ 'commons:basic.actions' | translate }}</span>
      </button>
      <div class="quickActions-moreMenu" *ngIf="toggleMoreMenu" (mouseleave)="toggleMoreMenu = false">
        <ul>
          <li class="mainAction cng-ico_transfRaccro">
            <button (click)="validate()">{{ 'agent:contact.actions.validate_transfer' | translate }}</button>
          </li>
          <li class="mainAction cng-ico_annuler" *ngIf="!isDialingTarget">
            <button (click)="cancel()">{{ 'agent:contact.actions.cancel_transfer' | translate }}</button>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
